module.exports = __webpack_public_path__ + "img/43_4.9ba54ee7.png";